import axios from "axios";
import HttpAPICall from "../../../services/HttpAPICall";
import { OMNI_COMM_AUTH_LOGIN_FAILURE, OMNI_COMM_AUTH_LOGIN_START, OMNI_COMM_AUTH_LOGIN_SUCCESS } from "../actionTypes";

export const authLoginAndGetJWTToken = () => {
    return (dispatch) => {
        dispatch({ type: OMNI_COMM_AUTH_LOGIN_START });
        const url           =   "https://online.omnicomm.in/auth/login?jwt=1";
        const data          =   {
            "login"             :   "tappetbox_dealer", //"rudemoru",
            "password"          :   "tappetbox11151"   //"rudemo123456",
        }
        HttpAPICall.withAthorization("POST", url, null, {}, data)
        .then((response) => {
            dispatch({ type: OMNI_COMM_AUTH_LOGIN_SUCCESS, payload: response.data});
        }).catch((err) => {
            dispatch({ type: OMNI_COMM_AUTH_LOGIN_FAILURE, payload : err });
        });
    };
}; 

export const refreshJWTToken = (refresh) => {
    return async (dispatch) => {
        try {
            const url           =   "https://online.omnicomm.in/auth/refresh";
            dispatch({ type: OMNI_COMM_AUTH_LOGIN_START });
            
            let response        =   await axios({
                url,
                method : 'POST',
                headers : {
                    'Content-Type'  :   'application/json',
                    'Authorization' :   'JWT ' + refresh
                }
            });
            
            dispatch({ type: OMNI_COMM_AUTH_LOGIN_SUCCESS, payload: response.data});
    
        } catch (error) {
            dispatch({ type: OMNI_COMM_AUTH_LOGIN_FAILURE, payload : error });
    
        }
    };

}; 

